import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, ShoppingCart, BarChart3, Settings, Users, Webhook, LogOut, Phone, Menu, X, Zap, Briefcase } from 'lucide-react';

const Sidebar = () => {
  const { user, logout, isAdmin, can } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  
  const hasCommercial = user?.plan === 'enterprise' || user?.role === 'admin';

  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard', module: 'dashboard' },
    { path: '/sales', icon: ShoppingCart, label: 'Vendas', module: 'sales' },
    { path: '/campaigns', icon: BarChart3, label: 'Campanhas', module: 'campaigns' },
    { path: '/automations', icon: Zap, label: 'Automações', module: 'automations' },
    ...(hasCommercial ? [{ path: '/utms', icon: Briefcase, label: 'Gestão Comercial', module: 'sellers' }] : []),
    { path: '/webhooks', icon: Webhook, label: 'Integrações', module: 'webhooks' },
    { path: '/whatsapp-health', icon: Phone, label: 'Saúde WhatsApp', module: 'whatsapp' },
    { path: '/settings', icon: Settings, label: 'Configurações', module: 'settings' },
  ];
  


  const closeSidebar = () => setIsOpen(false);
  
  return (
    <>
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-gray-900 border-b border-gray-800 px-4 py-3 flex items-center justify-between">
        <h1 className="text-xl font-bold text-white"><span className="text-blue-500">J</span>-Tracker</h1>
        <button onClick={() => setIsOpen(!isOpen)} className="text-gray-400 hover:text-white p-2">{isOpen ? <X size={24} /> : <Menu size={24} />}</button>
      </div>
      {isOpen && <div className="lg:hidden fixed inset-0 bg-black/50 z-40" onClick={closeSidebar} />}
      <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-gray-900 min-h-screen flex flex-col transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'} lg:transform-none`}>
        <div className="p-6 border-b border-gray-800 hidden lg:block">
          <h1 className="text-2xl font-bold text-white"><span className="text-blue-500">J</span>-Tracker</h1>
          <p className="text-xs text-gray-500 mt-1">Sistema de Rastreamento</p>
        </div>
        <div className="h-14 lg:hidden" />
        <nav className="flex-1 p-4 overflow-y-auto">
          <ul className="space-y-2">
            {menuItems.filter(item => !item.module || can(item.module)).map((item) => (
              <li key={item.path}>
                <NavLink to={item.path} onClick={closeSidebar} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}>
                  <item.icon size={20} />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="p-4 border-t border-gray-800">
          <div className="flex items-center gap-3 px-4 py-3">
            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold">{user?.name?.charAt(0).toUpperCase()}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium truncate">{user?.name}</p>
              <p className="text-gray-500 text-xs truncate">{user?.email}</p>
            </div>
          </div>
          <button onClick={() => { logout(); closeSidebar(); }} className="flex items-center gap-3 px-4 py-3 w-full text-gray-400 hover:text-red-400 transition-colors">
            <LogOut size={20} />
            <span>Sair</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
